// Minimal mutations - FOR BULK DELETE / RESET
//
// The autogenerated delete* mutations in mutations.js return a deeply nested
// selection set (e.g. deleteInboundShipment → timeslot.reloadYardId). When
// sibling rows have already been deleted or carry stale/null fields, the delete
// response fails serialization on a non-nullable field even though the row
// itself was deleted successfully ("Cannot return null for non-nullable type
// ..."). The minimal variants here select only { id } to avoid traversing
// dangling connections during bulk delete / yard reset.
// ##########################################
export const deleteTimeslotIdOnly = /* GraphQL */ `
  mutation DeleteTimeslot($input: DeleteTimeslotInput!) {
    deleteTimeslot(input: $input) {
      id
    }
  }
`;

export const deleteTrackCarIdOnly = /* GraphQL */ `
  mutation DeleteTrackCar($input: DeleteTrackCarInput!) {
    deleteTrackCar(input: $input) {
      id
    }
  }
`;

export const deleteInventoryItemIdOnly = /* GraphQL */ `
  mutation DeleteInventoryItem($input: DeleteInventoryItemInput!) {
    deleteInventoryItem(input: $input) {
      id
    }
  }
`;

// Orphan cleanup: the condition pins the row to the parent and yard the audit
// saw, so a row that changed since the audit is left alone.
export const deleteInventoryItemIdOnlyIf = /* GraphQL */ `
  mutation DeleteInventoryItem(
    $input: DeleteInventoryItemInput!
    $condition: ModelInventoryItemConditionInput
  ) {
    deleteInventoryItem(input: $input, condition: $condition) {
      id
    }
  }
`;

export const deleteInventorieIdOnly = /* GraphQL */ `
  mutation DeleteInventorie($input: DeleteInventoryInput!) {
    deleteInventorie(input: $input) {
      id
    }
  }
`;

export const deleteInboundShipmentIdOnly = /* GraphQL */ `
  mutation DeleteInboundShipment($input: DeleteInboundShipmentInput!) {
    deleteInboundShipment(input: $input) {
      id
    }
  }
`;

export const deleteCarrierIdOnly = /* GraphQL */ `
  mutation DeleteCarrier($input: DeleteCarrierInput!) {
    deleteCarrier(input: $input) {
      id
    }
  }
`;

export const deleteCarrierUserIdOnly = /* GraphQL */ `
  mutation DeleteCarrierUser($input: DeleteCarrierUserInput!) {
    deleteCarrierUser(input: $input) {
      id
    }
  }
`;

export const deleteCarrierUserReloadYardCarrierIdOnly = /* GraphQL */ `
  mutation DeleteCarrierUserReloadYardCarrier(
    $input: DeleteCarrierUserReloadYardCarrierInput!
  ) {
    deleteCarrierUserReloadYardCarrier(input: $input) {
      id
    }
  }
`;

// The generated deleteCarrierCompany selects yards { items { ... } } — the
// company's Carrier entries, which the sweep has already deleted by the time
// this runs. Exactly the dangling-connection traversal this file exists to
// avoid.
export const deleteCarrierCompanyIdOnly = /* GraphQL */ `
  mutation DeleteCarrierCompany($input: DeleteCarrierCompanyInput!) {
    deleteCarrierCompany(input: $input) {
      id
    }
  }
`;

// The same minimal-selection-set reasoning applies to the bulk updates the
// carrierApp reset runs: clearing a carrier reference on thousands of shipments
// should not pull the whole shipment graph back on every row.
export const updateInboundShipmentIdOnly = /* GraphQL */ `
  mutation UpdateInboundShipment($input: UpdateInboundShipmentInput!) {
    updateInboundShipment(input: $input) {
      id
    }
  }
`;

export const updateOutboundShipmentIdOnly = /* GraphQL */ `
  mutation UpdateOutboundShipment($input: UpdateOutboundShipmentInput!) {
    updateOutboundShipment(input: $input) {
      id
    }
  }
`;

export const updateTimeslotIdOnly = /* GraphQL */ `
  mutation UpdateTimeslot($input: UpdateTimeslotInput!) {
    updateTimeslot(input: $input) {
      id
    }
  }
`;

export const deleteWorkChargeRuleIdOnly = /* GraphQL */ `
  mutation DeleteWorkChargeRule($input: DeleteWorkChargeRuleInput!) {
    deleteWorkChargeRule(input: $input) {
      id
    }
  }
`;

// The same { id }-only delete for any model, built from its type name. The yard
// delete removes some fifty models and would otherwise need a constant per model.
// Only for models that follow the transformer's naming, delete<Type> taking
// Delete<Type>Input — Inventory does not (deleteInventorie, above).
export const deleteIdOnly = (typeName) => /* GraphQL */ `
  mutation Delete${typeName}($input: Delete${typeName}Input!) {
    delete${typeName}(input: $input) {
      id
    }
  }
`;

// The update counterpart, for the reset's runtime-field writes. Same naming
// rule as deleteIdOnly.
export const updateIdOnly = (typeName) => /* GraphQL */ `
  mutation Update${typeName}($input: Update${typeName}Input!) {
    update${typeName}(input: $input) {
      id
    }
  }
`;
